import { Component } from '@angular/core';

@Component({
  selector: 'app-guide-enterprise-user-administration',
  templateUrl: './guide-enterprise-user-administration.component.html',
  styleUrls: ['./guide-enterprise-user-administration.component.scss']
})
export class GuideEnterpriseUserAdministrationComponent {

}
